import { render, staticRenderFns } from "./DataTableCopyModal.vue?vue&type=template&id=39a43a3b&"
import script from "./DataTableCopyModal.vue?vue&type=script&lang=js&"
export * from "./DataTableCopyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports